<div class="mmr-snackbar-outer">
   <div class="bs-icon-comment-o bs-icon"></div>
   <div class="bs-message">{{message}}</div>
   <div class="clear-both"></div>
</div>